<template>
  <div>
    <!-- <Header /> -->
    <div class="flex flex-col lg:flex-row">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-3 p-5">
          <!-- Search Bar -->
          <div class="flex justify-end items-center">
            <form class="flex"   @submit.prevent="searchUserValue">
              <input
                type="text"
                name="lead_search"
                id="lead_search"
                v-model="searchvalue"
                  @input="searchUserValue"
                placeholder="Search"
                class="border-2 rounded-l-xl px-4 py-2 w-[80%] lg:w-[230px] outline-none"
              />
              <button
                type="submit"
                class="bg-blues py-1 rounded-r-xl text-white px-5"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-7 h-7"
                  viewBox="0,0,256,256"
                >
                  <g fill="#fbf7f7">
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M21,3c-9.37891,0 -17,7.62109 -17,17c0,9.37891 7.62109,17 17,17c3.71094,0 7.14063,-1.19531 9.9375,-3.21875l13.15625,13.125l2.8125,-2.8125l-13,-13.03125c2.55469,-2.97656 4.09375,-6.83984 4.09375,-11.0625c0,-9.37891 -7.62109,-17 -17,-17zM21,5c8.29688,0 15,6.70313 15,15c0,8.29688 -6.70312,15 -15,15c-8.29687,0 -15,-6.70312 -15,-15c0,-8.29687 6.70313,-15 15,-15z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </button>
            </form>
          </div>

          <!-- Table -->
          <div class="overflow-x-auto">
            <table class="table-auto w-full">
              <thead class="">
                <tr>
                  <th
                    class="p-3 border text-left border-r text-blues whitespace-nowrap"
                  >
                    S NO
                  </th>
                  <th class="p-3 border text-left border-r text-blues">
                    Title
                  </th>
                  <th
                    class="p-3 border text-left border-r text-blues whitespace-nowrap"
                  >
                    Permission
                  </th>
                   <th
                    class="p-3 border text-left border-r text-blues whitespace-nowrap"
                  >
                    Email
                  </th>
                  <th
                    class="p-3 border text-left border-r text-blues whitespace-nowrap"
                  >
                    Created Date
                  </th>
                </tr>
              </thead>

              <!-- Data Rows -->
              <tbody v-if="bloglist.length>0">
                <tr
                  v-for="(blog, index) in bloglist"
                  :key="blog.id"
                  class="text-sm"
                >
                  <td class="p-3 border">
                    <p class="text-primary">{{ index + 1 }}</p>
                  </td>
                  <td class="p-3 border">
                    <p v-if="blog.title" class="text-primary text-wrap">
                      {{ blog.title }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                  <td class="p-3 border whitespace-nowrap">
                    <p v-if="blog.bolger_id.display_name" class="text-primary">
                      {{ blog.bolger_id.display_name }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                   <td class="p-3 border whitespace-nowrap">
                    <p v-if="blog.bolger_id.email" class="text-primary">
                      {{ blog.bolger_id.email }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                  <td class="p-3 border whitespace-nowrap">
                    <p v-if="blog.create_date" class="text-primary">
                      {{formatDate( blog.create_date) }}
                    </p>
                    <p v-else class="text-primary">NA</p>
                  </td>
                </tr>
              </tbody>

              <!-- Empty State -->
              <tbody v-else>
                <tr>
                  <td colspan="8" class="text-center py-6">
                    <div
                      class="w-full flex justify-center items-center text-gray-500"
                    >
                      No Data Found
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Hod/Header.vue";
import SideBar from "@/components/Hod/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      searchvalue: "",
      totalPages: null,
      currentPage: 1,
      bloglist: [],
    };
  },
 computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.fetchBlogs(1);
  },
  methods: {
    formatDate(date) {
  return new Date(date).toISOString().split("T")[0];
},

    fetchBlogs(value) {
      this.currentPage = value;
      axios
        .get(
          `${process.env.VUE_APP_API}/blog-details/list/?page=${value}&Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.bloglist = res.data.data.data;
            this.blogcount = res.data.total;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            this.totalPages = res.data.total_page;
          }
        })
        .catch((error) => {
          console.error("Error fetching blogs:", error);
        });
    },
     async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/blog-details/list/?search=${this.searchvalue}&Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.bloglist = res.data.data.data;
            this.blogcount = res.data.total;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            this.totalPages = res.data.total_page;
          }
        })
        .catch((error) => {
          console.error("Error fetching blogs:", error);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
